import { ValidateActionsEndpointReturnType } from './types';
import { IAuthProviderService } from '../../../services/authProviderService';
import { JarvisWebHttpClient } from '@jarvis/web-http';
import { ApplicationContextEnum } from '../../../services/applicationService/enums';
import { getStratusBaseUrl } from '../../../clients/stackUtils';
import IApplicationService from '../../../services/applicationService/IApplicationService';

export async function validateActions(
  authProvider: IAuthProviderService,
  applicationService: IApplicationService,
  actionsToValidate: string[]
): Promise<string[]> {
  const httpClient = new JarvisWebHttpClient({
    defaultAuthProvider: authProvider
  });

  const baseUrl = resolveBaseUrl(applicationService);
  const url = '/session/v1/validate-actions';

  const response: { data: ValidateActionsEndpointReturnType } =
    await httpClient.post({
      url: `${baseUrl}${url}`,
      data: {
        actions: actionsToValidate
      }
    });

  return response?.data?.actions;
}

function resolveBaseUrl(applicationService: IApplicationService): string {
  const applicationContext = applicationService.getApplicationContext();

  if (applicationContext === ApplicationContextEnum.ADAPTER) {
    const portalStack = applicationService.getPortalStack();
    return `${getStratusBaseUrl(portalStack)}/portalsvc`;
  }

  return '/api';
}
